import { render, staticRenderFns } from "./SBCheckbox.html?vue&type=template&id=eec61374&scoped=true&"
import script from "./SBCheckbox.ts?vue&type=script&lang=ts&"
export * from "./SBCheckbox.ts?vue&type=script&lang=ts&"
import style0 from "./SBCheckbox.css?vue&type=style&index=0&id=eec61374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec61374",
  null
  
)

export default component.exports